export const RATING_TITLE = 'Альфа-Рейтинг';
export const DEFAULT_OVERVIEW_ARTICLE_LABEL_TEXT = 'Рынок за 180 секунд';
export const SCORE_TYPE_NAMES = ['potential', 'history', 'dividends', 'stability', 'fundamentals'];
export const TOTAL_SCORE_TYPE_NAME = 'total';
export const TOTAL_PREVIOUS_SCORE_TYPE_NAME = 'total_previous';
export const ALL_NEEDED_SCORE_TYPE_NAMES = [
    TOTAL_SCORE_TYPE_NAME,
    TOTAL_PREVIOUS_SCORE_TYPE_NAME,
    ...SCORE_TYPE_NAMES,
];

export const MIN_SCORE_VALUE = 0;
export const MAX_SCORE_VALUE = 10;
export const EMPTY_SCORE_VALUE = '-';

export const RATING_HINT_TEXT =
    'Оценивает акции от 1 до 10 по каждому из параметров, основываясь на анализе их показателей и мнениях инвестиционных домов';

export const ERROR_REQUEST_FOR_MEDIAPORTAL =
    'An error occurred while requesting data from the Mediaportal service';

export const SSR_MEDIAPORTAL_PROMISE_NAMES = {
    MEDIAPORTAL_ARTICLE: 'MEDIAPORTAL_ARTICLE',
    MEDIAPORTAL_EMITENTS_DETAIL_PAGE: 'MEDIAPORTAL_EMITENTS_DETAIL_PAGE',
    MEDIAPORTAL_MAIN_HEADER: 'MEDIAPORTAL_MAIN_HEADER',
    MEDIAPORTAL_MAIN_INFORMATION: 'MEDIAPORTAL_MAIN_INFORMATION',
    MEDIAPORTAL_EMITENTS_RATING: 'MEDIAPORTAL_EMITENTS_RATING',
    MEDIAPORTAL_EMITENTS_TABLE_RATING: 'MEDIAPORTAL_EMITENTS_TABLE_RATING',
    MEDIAPORTAL_SEARCH: 'MEDIAPORTAL_SEARCH',
};

// TODO такие-же константы находятся в invest-emitents-common/src/constants/common.ts
// желательно в будущем избавиться от дублей и перенести их в пакет invest-common
export const PROFITABILITY_TYPE_DAY = 'DAY' as const;
export const PROFITABILITY_TYPE_WEEK = 'WEEK' as const;
export const PROFITABILITY_TYPE_MONTH = 'MONTH' as const;
export const PROFITABILITY_TYPE_THREEMONTHS = 'THREEMONTHS' as const;
export const PROFITABILITY_TYPE_YEAR = 'YEAR' as const;
export const PROFITABILITY_TYPE_YTM = 'YTM' as const; // yield to maturity

/** Подстроки для поиска и замены на реальные ISIN или ticker в полученном из публичных пропсов конфиге baseUrlToAsset */
export const BASE_URL_TO_ASSET_SUBSTRING = {
    ISIN: '[isin]',
    TICKER: '[ticker]',
};

export const ERROR_IMAGE_LINK = 'https://alfabank.st/site-upload/26/25/3156/face_thinking.png';
